import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";
import { ICountryIndexResource } from "../types";
import { EventCalendarSettingSaveRequest, EventCalendarSettingUpdateResource } from "../types/eventCalendarSetting";

const baseKey = "event-calendar-settings";
const countryOptionsKey = [baseKey, "country-options"];

export const eventCalendarSettingService = {
	showKey: [baseKey],
	show: () => {
		return axios.get<LaravelResponse<EventCalendarSettingUpdateResource>>(keyToUrl([baseKey]));
	},
	update: (entity: EventCalendarSettingSaveRequest) => {
		return axios.put(keyToUrl([baseKey]), entity);
	},
	countryOptionsKey,
	countryOptions: (search: string, page: number) => {
		return axios.get<LaravelResponse<ICountryIndexResource[]>>(keyToUrl(countryOptionsKey), {
			params: {
				search,
				page,
			},
		});
	},
};
